/* eslint-disable no-restricted-globals */
import React from "react";

import { Box, Button, Link, Menu, MenuItem, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";

const Footer = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className="footer">
      <Box className="contents-area">
        <Grid2>
          <Grid2
            container
            display={"flex"}
            direction={"row"}
            justifyContent={"space-between"}
            textAlign="start"
            pt={"80px"}
            pb={"20px"}
          >
            <Grid2 item xs={12} md={8}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <Box>
                  <Typography>
                    (사)길벗사랑공동체 해피인 | 대표자 : 박보아
                  </Typography>
                  <Typography>주소 : 서울 관악구 신림로 19길 68</Typography>
                  <Typography>Tel : 0507-1321-6216 / 010-5271-6216</Typography>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography>Email : </Typography>
                    <Typography ml={1}>
                      lucia6211@hanmail.net
                      <br />
                      happyin3217@daum.net
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography sx={{ alignItems: "end" }}>
                    Copyright ⓒ HAPPYIN. ALL RIGHTS RESERVED.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Box item xs={12} md={4} mb={1} width={"350px"}>
              <Box mb={1}>
                <Typography>후원 전용 계좌번호</Typography>
                <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid black",
                    py: 0.5,
                    borderRadius: 0,
                    textAlign: "center",
                  }}
                >
                  <Typography>
                    <strong>우리은행 1005 203 129028</strong>
                    <br />
                    (예금주 : (사)길벗사랑공동체)
                  </Typography>
                </Box>
              </Box>
              {/* <Box
                mb={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <img
                    className="logo_icon"
                    src={logo_kakao}
                    alt="카카오톡 친구추가"
                    style={{ marginRight: "10px" }}
                  />
                  <Typography>카카오톡 친구추가</Typography>
                </Box>

                <Typography borderRight={1}></Typography>
                <a href={NAVER_CAFE_LINK}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <img
                      className="logo_icon"
                      src={logo_naver_cafe}
                      alt="네이버 카페 가입"
                      style={{ marginRight: "10px" }}
                    />
                    <Typography>네이버 카페 가입</Typography>
                  </Box>
                </a>
              </Box> */}
              <Box>
                <Button
                  id="demo-positioned-button"
                  aria-controls={open ? "demo-positioned-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  sx={{
                    width: "100%",
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid black",
                    py: 0.2,
                    borderRadius: 0,
                  }}
                >
                  Family Site
                </Button>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <Link
                    href="https://www.gwanak.go.kr/site/gwanak/ex/dept/DongMain.do?cdIdx=D3200168"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem
                      sx={{
                        width: "300px",
                        backgroundColor: "white",
                      }}
                    >
                      <Typography width={"parent"}>대학동 주민센터</Typography>
                    </MenuItem>
                  </Link>
                  <Link
                    href="https://www.pska21.or.kr/"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem
                      sx={{
                        width: "100%",
                        backgroundColor: "white",
                      }}
                      onClick={handleClose}
                    >
                      관악주민연대 주거복지센터
                    </MenuItem>
                  </Link>

                  <MenuItem onClick={handleClose}>관악사회복지</MenuItem>

                  <Link
                    href="https://poor.or.kr/?page_id=3247"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem onClick={handleClose}>참소중한</MenuItem>
                  </Link>
                  <Link
                    href="http://www.smw.or.kr/"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem onClick={handleClose}>
                      성민종합사회복지관
                    </MenuItem>
                  </Link>
                  <Link
                    href="http://gase.kr"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem onClick={handleClose}>
                      관악사회적경제지원센터
                    </MenuItem>
                  </Link>
                  <Link
                    href="https://www.1wool.or.kr/"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem onClick={handleClose}>
                      한울정신건강지원센터
                    </MenuItem>
                  </Link>
                  <Link
                    href="https://www.gwanakmaum.or.kr/"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem onClick={handleClose}>
                      관악구 정신건강복지센터
                    </MenuItem>
                  </Link>
                  <MenuItem onClick={handleClose}>부천 연세차치과의원</MenuItem>
                  <MenuItem onClick={handleClose}>
                    KT&G 남서울본부 관악지사
                  </MenuItem>
                  <Link
                    href="https://www.jungmc.org/"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem onClick={handleClose}>관악 정다운</MenuItem>
                  </Link>
                  <Link
                    href="https://www.conet.or.kr/"
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <MenuItem onClick={handleClose}>
                      한국주민운동교육원
                    </MenuItem>
                  </Link>
                </Menu>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </div>
  );
};

export default Footer;
